import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';

export function useServerDepartmentValidation<T>(
	newGroupMutation: UseMutationResult<
		ApiResponse<any>,
		unknown,
		void,
		unknown
	>,
	form: UseFormReturnType<T, (values: T) => T>,
) {
	useEffect(() => {
		if (!newGroupMutation.data?.isValid) {
			newGroupMutation.data?.validationMessages.forEach((v) => {
				if (v.inputIdentifier === 'DepartmentName') {
					form.setFieldError('departmentName', v.validationMessage);
				}
			});
		}
	}, [newGroupMutation.data?.validationMessages]);
}
